(ns com.theplantscape.plant-web.draw.actions
  (:require
   [com.theplantscape.local-store.ensemble
    :as db
    :refer [fetch-diagram-id fetch-plant]]
   [com.theplantscape.browser-utils.ensemble :refer [open-in-new-tab]]
   [com.theplantscape.plant-web.api.plants :refer [share-svg share-svg-url]]
   [com.theplantscape.plant-web.components.search :as c]
   [com.theplantscape.plant-web.components.tiles :refer [plant-tile]]
   [com.theplantscape.plant-web.draw.components.ui-svg-diagram
    :refer [ui-svg-diagram]]
   [com.theplantscape.plant-web.draw.db-store :as db-local-store]
   [com.theplantscape.plant-web.draw.events :as evt :refer [reset-state]]
   [com.theplantscape.plant-web.draw.state
    :refer [app-state configure-modal set-mode move-canvas]]
   [com.theplantscape.web-ui.svg.helpers :refer [export-svg]]))

(defn plant-info-modal [eid]
  (swap!  app-state assoc :plant (fetch-plant eid))
  (configure-modal "Plant details" [plant-tile (fetch-plant eid)]))

(defn select-tool-modal
  [modal-cfg]
  (configure-modal
   (:title modal-cfg)
   (:body modal-cfg)))

(defn configure-tool
  ([mode body] (configure-tool mode body nil))
  ([mode body tool]
   (set-mode mode tool)
   (configure-modal "Search" body)))

(defn set-tool [tool]
  (case tool
    :set-structure-tool
    (set-mode :insert :structure)
    :set-patch-tool
    (set-mode :insert :patch)
    :set-area-tool
    (set-mode :insert :area)
    :set-path-tool
    (set-mode :insert :path)
    :set-measure
    (set-mode :measure :ruler)
    :set-search-tool
    (configure-tool :insert [c/ui-plant-search c/search-modal])
    :center-canvas
    (move-canvas 0 0)
    :reset-diagram
    (reset-state)
    :share-svg
    (share-svg-url (fetch-diagram-id) )
    :export-svg
    (export-svg [ui-svg-diagram 600 600])
    :save
    (db-local-store/store-database db/diag)
    :load
    (db-local-store/restore-database db/diag)))
